module.exports = __webpack_public_path__ + "static/img/exam_empty.5046c05e.png";